/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportReviewsMutationVariables = Types.Exact<{
  object: Types.ImportReviewsInput;
}>;

export type ImportReviewsMutation = { __typename?: 'mutation_root'; import_reviews: string };

export const ImportReviewsDocument = `
    mutation ImportReviews($object: ImportReviewsInput!) {
  import_reviews(object: $object)
}
    ` as string & TypedDocumentNode<ImportReviewsMutation, ImportReviewsMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportReviews: build.mutation<ImportReviewsMutation, ImportReviewsMutationVariables>({
      query: (variables) => ({ document: ImportReviewsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportReviewsMutation } = injectedRtkApi;
